<pre>{{ metadata$ | async | json }}</pre>
